'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { GoogleTagManager } from '@next/third-parties/google';
import { datadogRum } from '@datadog/browser-rum';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID as string;

const MarketingScriptManager = () => {
  const [isMounted, setIsMounted] = useState(false);
  const pathName = usePathname();

  useEffect(() => {
    setIsMounted(true);
  }, [pathName]);

  useEffect(() => {
    if (!isMounted) return;

    const isProd = process.env.NEXT_PUBLIC_APP_STAGE === 'prod';
    const sampleRate = isProd ? 20 : 100;
    const replaySampleRate = 100;

    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID as string,
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN as string,
      site: 'datadoghq.com',
      service: 'yozm',
      env: process.env.NEXT_PUBLIC_APP_STAGE,
      sessionSampleRate: sampleRate,
      sessionReplaySampleRate: replaySampleRate,
      defaultPrivacyLevel: 'allow',
      allowedTracingUrls: [
        /https:\/\/.*\.wishdev\.net/,
        /https:\/\/.*\.wishket\.com/,
        process.env.NEXT_PUBLIC_APP_AUTH_URL as string,
        process.env.NEXT_PUBLIC_APP_BASE_URL as string,
        process.env.NEXT_PUBLIC_APP_BASE_API_URL as string,
        (url) => url.startsWith(process.env.NEXT_PUBLIC_APP_AUTH_URL as string),
        (url) =>
          url.startsWith(process.env.NEXT_PUBLIC_APP_BASE_API_URL as string),
        (url) => url.startsWith(process.env.NEXT_PUBLIC_APP_BASE_URL as string),
      ],
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
    });
  }, [isMounted]);

  if (!isMounted) return <></>;

  return <>{GTM_ID && <GoogleTagManager gtmId={String(GTM_ID)} />}</>;
};

export default MarketingScriptManager;
